import React from 'react'

import classNames from 'classnames'

import helper from 'emailThreadViewer/helper'

import styles from './style.module.scss'

interface FTIconProps {
  fileName: string
  size?: number
  className?: string
  colorType?: string
}

interface FTIconState {
  imgSrc: string
  text: string | null
  size: number | null
  alt: string
}

class FTIcon extends React.Component<FTIconProps, FTIconState> {
  state: FTIconState = {
    imgSrc: '',
    text: null,
    size: null,
    alt: '',
  }

  async componentDidMount(): Promise<void> {
    await this.applyProps()
  }

  async componentDidUpdate(prevProps: FTIconProps): Promise<void> {
    const { fileName, size } = this.props

    if (fileName !== prevProps.fileName || size !== prevProps.size) {
      await this.applyProps()
    }
  }

  componentWillUnmount(): void {}

  applyProps = async (): Promise<void> => {
    const { fileName, size } = this.props

    // console.log(fileName, fileType, size)

    const fileIconState = await helper.getFileIcon(fileName)

    this.setState((prevState) => ({
      ...prevState,
      ...fileIconState,
      size: size ?? null,
    }))
  }

  render(): React.ReactElement {
    const { imgSrc, text, size, alt } = this.state
    const { className } = this.props

    const styleProps: React.CSSProperties = {}
    if (size != null) {
      styleProps.width = size
    }

    const textElem = text != null ? <div className={classNames('type')}>{text}</div> : ''

    return (
      <div className={classNames(styles.ftIcon, 'ftIcon', className)}>
        <img src={imgSrc} style={styleProps} alt={alt} />
        {textElem}
      </div>
    )
  }
}

export default FTIcon
